import { registerLocaleData } from '@angular/common';
import localePt from '@angular/common/locales/pt';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { registerEcharts } from './app/core/config/echarts.config';

registerEcharts();

// Mapa do Brasil: o registro está desativado desde a AE-700, pronto para voltar.
//
// Ninguém desenha mapa hoje — não existe série `type: 'map'` no código, nada registrava
// `MapChart`/`GeoComponent`, e o `ai-chart.ts` limita a `bar`/`line`/`pie` os tipos que a IA
// consegue gerar. O GeoJSON dos estados (`public/assets/brazil-uf.ts`) pesa 2,5 MB e ia inteiro
// para o bundle inicial.
//
// Este arquivo também importava o pacote `echarts` completo só para chamar o `registerMap`, e
// essa importação passava por cima da lista do `echarts.use()` em `core/config/echarts.config.ts`:
// registrava tudo, então qualquer omissão da lista funcionava por acidente.
//
// Para reativar: descomente as três linhas abaixo e o `MapChart`/`GeoComponent` na configuração.
// O `registerMap` vem do `echarts/core` — a mesma instância que o `provideEchartsCore` entrega à
// diretiva do ngx-echarts — e não do pacote completo, senão o acidente volta junto.
//
// import { registerMap } from 'echarts/core';
// import { BRAZIL_UF_GEOJSON } from 'public/assets/brazil-uf';
// registerMap('brazil', BRAZIL_UF_GEOJSON);

// Registra locale para pt-BR (necessário para pipes/formatters)
registerLocaleData(localePt, 'pt-BR');

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
